const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the Translation Manager Directive which displays and handles translations
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {$rootScope} $rootScope Root Scope accessing service
 */
app.directive('translationsManager', [function () {
    return {
      restrict: 'E',
      template: require('../../templates/directives/translations-manager.html'),
      controller: ['$scope', '$window', function ($scope) {
          
          var self = this;
          var categoryData = {};
          var keyStore = {};
          self.showCategorySelect = false;
          self.showSubcategorySelect = false;
          self.showKeySection = false;
          self.selectedLanguage = "";
          self.selectedCategory = "";
          self.selectedSubcategory = "";
          self.subcategories = [];
          self.currentKeys = [];

          //TODO: get these dynamically
          self.languages = [
            {
              name: 'English',
              value: 'ENG'
            },
            {
              name: 'Spanish',
              value: 'SPA'
            },
            {
              name: 'German',
              value: 'GER'
            }
          ];


          self.getCategoryData = function(){

            //TODO: Mockdata, replace w/ real data
            return {
              'global': {

                'displayName' : 'Global',
                'subcategories' : {

                  'contentTypes' : 'Content Types',
                  'forms': 'Forms'
                }
              },
              'dashboard': {

                'displayName' : 'User Dashboard',
                'subcategories' : {

                  'activity':  'Activity',
                  'tracks': 'Tracks'
                }
              }
            };

          };

          self.getKeyData = function(language){

            //TODO: Mockdata, replace w/ real data

            var tempStore = {};

            if (language !== "ENG") {

              //load additional language(s)
              tempStore.SPA={global:{contentTypes:{generic:{copy:"Contenido",description:"Label for a Content item"},genericPlural:{copy:"Contenidos",description:"Label for Content items"}},forms:{labels_chooseTopic:{copy:"Por Favor Selecciona un Tema",description:'Form label for "Choose Topic"'},labels_confirmPassword:{copy:"Confirmar Contraseña",description:'Form label for "Confirm Password"'}}},dashboard:{activity:{tabName:{copy:"Actividad",description:"Name of Activity Tab"},likes_headline:{copy:"Contenido que te gustó",description:"Headline of Likes section in Activity Tab"}},tracks:{completed_tabName:{copy:"Finalizada",description:"Name of Completed Tab"},growth_headline:{copy:"Tu Avance",description:'Headline of "Your Growth" panel'}}}};
              tempStore.GER={global:{contentTypes:{generic:{copy:"Inhalt",description:"Label for a Content item"},genericPlural:{copy:"Inhalte",description:"Label for Content items"}},forms:{labels_chooseTopic:{copy:"Bitte wählen Sie ein Thema aus",description:'Form label for "Choose Topic"'},labels_confirmPassword:{copy:"Passwort bestätigen",description:'Form label for "Confirm Password"'}}},dashboard:{activity:{tabName:{copy:"Aktivitäten",description:"Name of Activity Tab"},likes_headline:{copy:"Inhalte die Ihnen gefallen",description:"Headline of Likes section in Activity Tab"}},tracks:{completed_tabName:{copy:"Fertig bearbeitet",description:"Name of Completed Tab"},growth_headline:{copy:"Ihr Fortschritt",description:'Headline of "Your Growth" panel'}}}};
            }

            //load english (always needed);
            tempStore.ENG={global:{contentTypes:{generic:{copy:"Content",description:"Label for a Content item"},genericPlural:{copy:"Content",description:"Label for Content items"}},forms:{labels_chooseTopic:{copy:"Please Choose a Topic",description:'Form label for "Choose Topic"'},labels_confirmPassword:{copy:"Confirm Password",description:'Form label for "Confirm Password"'}}},dashboard:{activity:{tabName:{copy:"Activity",description:"Name of Activity Tab"},likes_headline:{copy:"Content You Like",description:"Headline of Likes section in Activity Tab"}},tracks:{completed_tabName:{copy:"Completed",description:"Name of Completed Tab"},growth_headline:{copy:"Your Growth",description:'Headline of "Your Growth" panel'}}}};
            return tempStore;

          };

          self.getCategories = function() {

            var categoriesArray = [];

            //request data
            categoryData = self.getCategoryData();

            //create array of objects for category select
            Object.keys(categoryData).forEach(function(key) {
                categoriesArray.push({
                  'name': categoryData[key].displayName,
                  'value' : key
                });
            });

            return categoriesArray;
          };

          self.getSubcategories = function(cat) {
            
            var subcategoriesArray = [];
            var subcategoriesObject = categoryData[cat].subcategories;

            //create array of objects for subcategory select
            Object.keys(subcategoriesObject).forEach(function(key) {
                subcategoriesArray.push({
                  'name': subcategoriesObject[key],
                  'value' : key
                });
            });

            return subcategoriesArray;
          };

          self.selectLanguage = function(lang) {

            self.selectedLanguage = lang;

            //get keys based on selected language
            keyStore = self.getKeyData(lang);

            //show view selection
            self.showCategorySelect = true;

            //reset settings when new language is chosen
            if (self.showSubcategorySelect) {
              self.categories.category = "";
              self.selectedCategory = "";
              self.selectedSubcategory = "";
              self.showSubcategorySelect = false;
              self.showKeySection = false;
            };

          };

          self.selectCategory = function(cat) {

            //hide subcategory select and key section
            self.showSubcategorySelect = false;
            self.showKeySection = false;

            //set selected category and name
            self.selectedCategory = cat;
            self.selectedCategoryName = categoryData[cat].displayName;

            //populate subcategories
            self.subcategories = self.getSubcategories(cat);

            //show subcategory select
            self.showSubcategorySelect = true;

          };

          self.getSubcategoryKeys = function(){

            //helper function to return subobject based on path string
            var getSubObject = function(obj, path){

              for (var i=0, path=path.split('.'), len=path.length; i<len; i++){
                obj = obj[path[i]];
              };
              return obj;
            };

            //path to subcategory and subcategory objects based on language
            var subcategoryPath = self.selectedCategory + '.' + self.selectedSubcategory;
            var subcategoryObjectEng = getSubObject(keyStore["ENG"], subcategoryPath);
            var subcategoryObjectI18n = (self.selectedLanguage === 'ENG') ? subcategoryObjectEng : getSubObject(keyStore, self.selectedLanguage + '.' + subcategoryPath);

            //create array of objects for current keys
            var subKeyObjectArray = [];
            Object.keys(subcategoryObjectEng).forEach(function(key) {
                
              subKeyObjectArray.push({
                'key' : subcategoryPath + "." + key,
                'description' : subcategoryObjectEng[key].description,
                'en' : subcategoryObjectEng[key].copy,
                'i18n' : subcategoryObjectI18n[key].copy,
                'edited' : subcategoryObjectI18n[key].copy.length === 0 ? false : true
              });
              
            });

            return subKeyObjectArray;

          };

          self.selectSubcategory = function(cat) {

            //set selected category and name
            self.selectedSubcategory = cat;
            self.selectedSubcategoryName = categoryData[self.selectedCategory].subcategories[cat];

            //get keys for selected subcategory
            self.currentKeys = self.getSubcategoryKeys();

            //show keys section
            self.showKeySection = true;

          };

          self.saveKeys = function() {
            
            //TODO: save values to DB

          };

          self.initialize = function () {
            //init
            self.categories = self.getCategories();
          };

          self.initialize();

          //watch language selection and update selected language if it differs from prev selection
          $scope.$watch('translations.languages.language', function (newValue, oldValue) {
            if (newValue !== oldValue && newValue !== self.selectedLanguage && newValue !== undefined) {
              self.selectLanguage(newValue);
            }
          });

          //watch category selection and update selected category if it differs from prev selection
          $scope.$watch('translations.categories.category', function (newValue, oldValue) {
            if (newValue !== oldValue && newValue !== self.selectedCategory && newValue !== undefined && newValue !== "") {
              self.selectCategory(newValue);
            }
          });

          //watch subcategory selection and update selected subcategory if it differs from prev selection
          $scope.$watch('translations.subcategories.subcategory', function (newValue, oldValue) {
            if (newValue !== oldValue && newValue !== self.selectedSubcategory && newValue !== undefined && newValue !== "") {
              self.selectSubcategory(newValue);
            }
          });

        }],

      controllerAs: 'translations'

    };
  }]);
